import { render, staticRenderFns } from "./homeDiabetes.vue?vue&type=template&id=2802e662"
import script from "./homeDiabetes.vue?vue&type=script&lang=js"
export * from "./homeDiabetes.vue?vue&type=script&lang=js"
import style0 from "./homeDiabetes.vue?vue&type=style&index=0&id=2802e662&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports